import { fontHeadingSerif } from './typographyNew';

export const textSerifTitle1 = fontHeadingSerif;

export const textSerifTitle2 =
  'font-serif md:text-40 md:leading-44 text-28 leading-32';

export const textTitle1 =
  'md:text-40 md:leading-48 text-28 leading-32 font-sans';

export const textTitle2 =
  'md:text-32 text-28 leading-tight font-sans font-medium';

export const textTitle3 =
  'md:text-28 text-24 leading-tight font-sans font-medium';

export const textBodyLarge =
  'md:text-20 md:leading-28 text-16 leading-22 font-sans';

export const textBody = 'text-16 leading-22 font-sans';

export const textBodyUppercase = 'uppercase text-16 leading-20 font-sans';

export const textBodySerif = 'text-16 font-serif leading-2';

export const textBodyUppercaseSmall = 'uppercase text-14 leading-18 font-sans';

export const textBodySmall = 'text-14 leading-20 font-sans';

export const textCaption = 'text-12 leading-16 font-sans';

export const textUppercaseBig = 'uppercase text-20 leading-24 font-sans';

export const textUppercaseCaption = 'uppercase text-12 leading-16 font-sans';
